import { useModal } from '@ebay/nice-modal-react'
import TimerModal from '../components/coin-shower-game/timer-modal'
import CoinShowerGame from '../components/coin-shower-game'
import { api } from '../utils/api-client'
import LoadingModal from '../components/common/loading-modal'
import { ApiResponse } from '../types/api'
import closeModal from '../utils/closeModal'
import dayjs from 'dayjs'
import LogInModal from '../components/common/log-in-modal'
import { useBoundStore } from '../store/store'
import { generateRandomNumber } from '../utils/number'

const useCoinGame = () => {
  const username = useBoundStore(state => state.user.username)
  const timerModal = useModal(TimerModal)
  const coinShowerGameModal = useModal(CoinShowerGame)
  const loadingModal = useModal(LoadingModal)
  const loginModal = useModal(LogInModal)

  const openGame = async () => {
    if (!username) {
      loginModal.show()
      return
    }
    loadingModal.show()
    try {
      const res = await api.post<
        ApiResponse<{
          last_claim_time: string
          total_deposit_today: string
          allowed_claim: 1 | 0
        }>
      >('/request.php', {
        type: 'bonus_history',
        version: 2,
      })
      closeModal(loadingModal)
      const { info, status } = res.data
      const claimTime = dayjs(info.last_claim_time)
      if (status === 1) {
        if (
          (dayjs().diff(claimTime, 'hours') >= 24 ||
            info.last_claim_time === null) &&
          info.allowed_claim
        ) {
          coinShowerGameModal.show({
            limit:
              +info.total_deposit_today * generateRandomNumber(0.008, 0.015),
          })
        } else {
          timerModal.show({ claimTime, disabled: !info.allowed_claim })
        }
      }
    } catch (error) {
      console.error(error)
      loadingModal.show()
    }
  }

  return openGame
}

export default useCoinGame
